import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "bddb3d0a-f649-4dd5-8586-178aaf10778c",
  solutionType: "equal-unordered-text-or-number-array",
  type: "custom010800",
  options: {},
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "equal-unordered-text-or-number-array",
  data: [0, 2, 5, 6, 8, 10, 11, 13, 14, 16, 18, 21, 22, 23, 24, 26, 29, 30, 32, 34, 35],
};
